import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DisplayDateTimePipe } from '@shared/core-utils';
import { SubscriptionManager } from '@tmx/core';
import { NavDropdownComponent } from '@tmx/operandi';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

import { displayTimeZone } from '../../utils/display-time-zone';
import { StatusPipe } from './pipes/status.pipe';
import { UnreadPipe } from './pipes/unread.pipe';
import { NotificationRepository } from './repositories/notification.repository';

@Component({
  selector: 'order-tracking',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    NavDropdownComponent,
    AsyncPipe,
    UnreadPipe,
    StatusPipe,
  ],
})
export class OrderTrackingComponent implements OnDestroy, OnInit {
  private readonly displayDateTimePipe = inject(DisplayDateTimePipe);
  private readonly notificationRepository = inject(NotificationRepository);
  private readonly sm = new SubscriptionManager();

  isOpen$ = new BehaviorSubject(false);

  notifications$ = this.notificationRepository.notifications$;

  unread$ = this.notificationRepository.unread$;

  disabled$ = this.notificationRepository.count$.pipe(
    map((count) => count === 0),
    tap((disabled) => {
      if (disabled) {
        this.isOpen$.next(false);
      }
    }),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  showUnread$ = combineLatest([this.isOpen$, this.unread$]).pipe(
    map(([isOpen, unread]) => !isOpen && unread > 0),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  displayTimeZone = displayTimeZone;

  ngOnInit() {
    this.notificationRepository.init();
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }

  openMenu() {
    this.isOpen$.next(true);
    this.notificationRepository.markAllRead();
  }

  closeMenu() {
    this.isOpen$.next(false);
  }

  formatDate(value: Date | null) {
    if (!value) {
      return '';
    }
    return this.displayDateTimePipe.transform(value, 'short');
  }
}
